import { useState, useEffect } from 'react';
import { Menu, X, Handshake, UserRound, LogIn } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/NavBar/aerocomp.png';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Home', path: '/' },
    { name: 'Product', path: '/products' },
    { name: 'About', path: '/about' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 z-50 w-full border-b border-white/10 transition-all duration-300 ${
          scrolled ? 'bg-[#0B0B0B]' : 'bg-[#0B0B0B]'
        } md:px-24 2xl:pl-24`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 text-white">
          {/* === Left: Logo === */}
          <Link to="/" className="flex items-center gap-2">
            <img
              src={logo}
              alt="AeroComp Logo"
              className="h-11 w-auto object-contain"
            />
            <span className="text-sm font-bold tracking-tighter text-white md:text-xl">
              AeroComp
            </span>
          </Link>

          {/* === Center: Nav Links (Desktop) === */}
          <div className="hidden items-center gap-20 text-sm md:flex">
            {links.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`relative transition-colors duration-300 ${
                    isActive
                      ? 'text-[#FFBD59] after:w-full'
                      : 'text-white hover:text-[#FFBD59]'
                  } after:absolute after:bottom-[-6px] after:left-0 after:h-[2px] after:bg-[#FFBD59] after:transition-all after:duration-300 ${
                    isActive ? 'after:w-full' : 'after:w-0 hover:after:w-full'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          {/* === Right: Buttons (Desktop) === */}
          <div className="hidden items-center gap-3 md:flex">
            {/* Login Button → NOW REDIRECTS */}
            <button
              onClick={() =>
                (window.location.href = 'https://admin.aerocomp.ph/')
              }
              className="flex items-center gap-1 rounded-md border border-[#FFBD59] px-5 py-3 text-xs text-[#FFBD59] shadow-[0_0_8px_#f5a62330] transition-all duration-300 hover:bg-[#FFBD59] hover:text-black hover:shadow-[0_0_12px_#f5a62360] md:text-[10px]"
            >
              <UserRound size={16} />
              Login
            </button>

            {/* Connect with us (opens in new tab) */}
            <button
              onClick={() => window.open('/appointmentsystem', '_blank')}
              className="flex items-center gap-1 rounded-md border border-[#FFBD59] px-4 py-3 text-xs font-medium text-[#FFBD59] transition-all hover:bg-[#FFBD59] hover:text-black md:text-[10px]"
            >
              <Handshake size={16} />
              Connect with us
            </button>
          </div>

          {/* === Mobile Menu Toggle === */}
          <button
            onClick={() => setOpen(!open)}
            className="text-white md:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* === Mobile Dropdown === */}
        {open ? (
          <div className="space-y-2 border-t border-white/10 bg-[#0B0B0B]/95 px-6 py-4 backdrop-blur-sm md:hidden">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setOpen(false)}
                className={`block py-1 text-sm transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#FFBD59]'
                    : 'text-white hover:text-[#FFBD59]'
                }`}
              >
                {link.name}
              </Link>
            ))}

            <div className="flex flex-col gap-2 pt-3">
              {/* Login (Mobile) → NOW REDIRECTS */}
              <button
                onClick={() =>
                  (window.location.href = 'https://admin.aerocomp.ph/')
                }
                className="flex items-center justify-center gap-1 rounded border border-[#FFBD59] px-4 py-2 text-sm font-medium text-[#FFBD59] transition-all hover:bg-[#FFBD59] hover:text-black"
              >
                <LogIn size={16} />
                Login
              </button>

              {/* Connect with us (mobile) */}
              <button
                onClick={() =>
                  window.open('/appointmentsystemlanding', '_blank')
                }
                className="flex items-center justify-center gap-1 rounded border border-[#FFBD59] px-4 py-2 text-sm font-medium text-[#FFBD59] transition-all hover:bg-[#FFBD59] hover:text-black"
              >
                <UserRound size={16} />
                Connect with us
              </button>
            </div>
          </div>
        ) : null}
      </nav>
    </>
  );
}
